import { File as FileIcon } from "lucide-react";
import { TellescopeModelFromName, useSecureFileUrl } from "@tellescope/tanstack-query";

export interface CarePlanFilePreviewProps {
  file: TellescopeModelFromName<"files">;
  size?: number;
}

export const CarePlanFilePreview = ({ file, size = 32 }: CarePlanFilePreviewProps) => {
  const isImage = file.type?.startsWith("image/") ?? false;
  const url = useSecureFileUrl(isImage ? file.secureName : undefined);

  if (isImage && url) {
    return (
      <img
        src={url}
        alt={file.name}
        className="rounded-sm object-cover flex-shrink-0"
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <div
      className="flex items-center justify-center rounded-sm bg-blue-50 flex-shrink-0"
      style={{ width: size, height: size }}
    >
      <FileIcon className="text-blue-500" size={Math.floor(size * 0.5)} />
    </div>
  );
};
